import {default as axios} from "axios";
import Vue from "vue";
import {ACCESS_TOKEN} from "@/api/auth.utils";

const POPUP_CONTENT_URL = process.env.VUE_APP_BOOKHERO_API_PATH + '/v1/content/management/popup';

export class PopupApiClient {
    getPopupContents(successCallback, errorCallback, finallyCallback = () => {}) {
        axios.get(POPUP_CONTENT_URL, {
            headers: {
                'Authorization': 'Bearer ' + Vue.$cookies.get(ACCESS_TOKEN)
            }
        }).then(response => {
            successCallback(response);
        }).catch(error => {
            errorCallback(error);
        }).finally(() => {
            finallyCallback();
        });
    }

    getPopupContent(id, successCallback, errorCallback, finallyCallback = () => {}) {
        axios.get(POPUP_CONTENT_URL + `/${id}`, {
            headers: {
                'Authorization': 'Bearer ' + Vue.$cookies.get(ACCESS_TOKEN)
            }
        }).then(response => {
            successCallback(response);
        }).catch(error => {
            errorCallback(error);
        }).finally(() => {
            finallyCallback();
        });
    }

    createPopupContent(data, successCallback, errorCallback, finallyCallback = () => {}) {
        axios.post(POPUP_CONTENT_URL, data, {
            headers: {
                'Authorization': 'Bearer ' + Vue.$cookies.get(ACCESS_TOKEN)
            }
        }).then(response => {
            successCallback(response);
        }).catch(error => {
            errorCallback(error);
        }).finally(() => {
            finallyCallback();
        });
    }

    updatePopupContent(id, data, successCallback, errorCallback, finallyCallback = () => {}) {
        axios.put(POPUP_CONTENT_URL + `/${id}`, data, {
            headers: {
                'Authorization': 'Bearer ' + Vue.$cookies.get(ACCESS_TOKEN)
            }
        }).then(response => {
            successCallback(response);
        }).catch(error => {
            errorCallback(error);
        }).finally(() => {
            finallyCallback();
        });
    }

    deletePopupContent(id, successCallback, errorCallback, finallyCallback = () => {}) {
        axios.delete(POPUP_CONTENT_URL + `/${id}`, {
            headers: {
                'Authorization': 'Bearer ' + Vue.$cookies.get(ACCESS_TOKEN)
            }
        }).then(() => {
            successCallback();
        }).catch(error => {
            errorCallback(error);
        }).finally(() => {
            finallyCallback();
        });
    }

    publishPopupContent(id, successCallback, errorCallback, finallyCallback = () => {}) {
        axios.post(POPUP_CONTENT_URL + `/${id}/publish`, {}, {
            headers: {
                'Authorization': 'Bearer ' + Vue.$cookies.get(ACCESS_TOKEN)
            }
        }).then(response => {
            successCallback(response);
        }).catch(error => {
            errorCallback(error);
        }).finally(() => {
            finallyCallback();
        });
    }

    deactivatePopup(id, successCallback, errorCallback, finallyCallback = () => {}) {
        axios.post(POPUP_CONTENT_URL + `/${id}/deactivate`, {}, {
            headers: {
                'Authorization': 'Bearer ' + Vue.$cookies.get(ACCESS_TOKEN)
            }
        }).then(response => {
            successCallback(response);
        }).catch(error => {
            errorCallback(error);
        }).finally(() => {
            finallyCallback();
        });
    }
}

export const popupApiClient = new PopupApiClient(); 